"use client";

import { useState, useEffect } from "react";

export default function OfficeAddressForm({ profile, onChange }: any) {
  const [address, setAddress] = useState("");
  const [locationUrl, setLocationUrl] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");

  const decodeHtml = (html: string) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  // Inisialisasi state dari profile
  useEffect(() => {
    if (!profile) return;

    setAddress(profile.address || "");

    if (profile.maps) {
      const decoded = decodeHtml(profile.maps);
      setLocationUrl(decoded);

      const match = decoded.match(/src="([^"]+)"/);
      if (match && match[1]) setPreviewUrl(match[1]);
    }
  }, [profile]);

  // Update preview & kirim valid ke parent
  useEffect(() => {
    // Ambil src dari iframe
    const match = locationUrl.match(/src="([^"]+)"/);
    if (match && match[1]) setPreviewUrl(match[1]);
    else setPreviewUrl("");

    // Valid kalau kosong atau diawali google maps embed
    const isValid =
      locationUrl === "" ||
      locationUrl.startsWith('<iframe src="https://www.google.com/maps/embed?');

    onChange?.({ address, map: locationUrl, isValid });
  }, [address, locationUrl]);

  return (
    <div className="space-y-4">
      <div>
        <label className="font-semibold text-sm">Company Address</label>
        <input
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          className="w-full p-3 border rounded-lg"
          placeholder="Enter company address"
        />
      </div>

      <div>
        <label className="font-semibold text-sm">Google Maps Embed Iframe</label>
        <textarea
          className="w-full p-3 border rounded-lg"
          rows={3}
          placeholder='<iframe src="https://www.google.com/maps/embed?..." ></iframe>'
          value={locationUrl}
          onChange={(e) => setLocationUrl(e.target.value)}
        />
        {locationUrl && !locationUrl.startsWith('<iframe src="https://www.google.com/maps/embed?') && (
          <span className="text-xs text-red-500 mt-1 block">
            Iframe harus diawali &lt;iframe src="https://www.google.com/maps/embed?
          </span>
        )}
        <span className="text-xs text-gray-500 mt-1 block">
          Cara mengambil link iframe Google Maps:<br />
          1. Buka Google Maps → cari lokasi.<br />
          2. Klik "Share" → pilih "Embed a map".<br />
          3. Copy code iframe.<br />
          4. Paste di textarea ini.
        </span>
      </div>

      {previewUrl && (
        <div className="rounded-lg overflow-hidden border mt-3">
          <iframe
            src={previewUrl}
            width="100%"
            height="150"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      )}
    </div>
  );
}
